import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ChangeDetectionStrategy
} from '@angular/core';

@Component({
  selector: 'aid-display-upload-file',
  template: `
    <div
      class="full-width full-height aid-layout-column aid-layout-align-center-start aid-layout-gap-32"
    >
      @if ((!displayedUrl && !showDefault) || (!defaultUrl && !displayedUrl)) {
        <div
          class="border-dashed border-radius-8 pointer upload__attach padding-16 aid-layout-column aid-layout-align-center-center"
          (click)="onFile()"
        >
          <mat-icon
            svgIcon="upload"
            color="accent"
            class="upload__icon"
          ></mat-icon>
          <span class="mat-subtitle-2 upload__text-color">
            {{ title | translate | sentancecase }}</span
          >
          @if (verticalSize && horizontalSize) {
            <span class="mat-small upload__text-color">
              {{ 'size' | translate | titlecase }} {{ horizontalSize }}x{{
                verticalSize
              }}
              px</span
            >
          }
          @if (!willCropPhoto && !circle) {
            <span class="mat-small upload__text-color">
              {{ 'recommended-size' | translate | titlecase }} 2 Mb</span
            >
          }
          @if (details) {
            <span class="mat-small upload__text-color">
              {{ details | translate }}
            </span>
          }
        </div>
      }
      @if (displayedUrl || (defaultUrl && showDefault)) {
        <div>
          <div
            class="upload__attach aid-layout-row aid-layout-align-center-center"
          >
            <div class="upload__preview  ">
              <img
                [src]="displayedUrl || defaultUrl"
                alt=""
                [height]="heightImage"
                [width]="widthImage"
                [ngClass]="{
                  'upload__preview--circle': circle
                  }"
              />
              <mat-icon
                class="upload__preview__clear pointer"
                svgIcon="close"
                (click)="onCancel()"
              ></mat-icon>
            </div>
          </div>
        </div>
      }
    </div>
  `,
  styleUrls: ['./display-upload-file.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class DisplayUploadFileComponent implements OnInit {
  @Input() horizontalSize?: number;
  @Input() verticalSize?: number;
  @Input() title: string | undefined = 'upload-photo';
  @Input() details?: string;

  @Input() circle = false;
  @Input() defaultUrl?: string;
  @Input() displayedUrl?: string | null;
  @Input() willCropPhoto?: boolean;
  @Input() showDefault?: boolean;

  @Input() width?: number | null;
  @Input() height?: number | null;

  @Output() upload: EventEmitter<void> = new EventEmitter();
  @Output() cancelPhoto: EventEmitter<void> = new EventEmitter<void>();

  widthImage?: number;
  heightImage?: number;
  constructor() {}

  ngOnInit() {
    if (this.circle) {
      this.widthImage = 150;
      this.heightImage = 150;
    } else {
      this.widthImage = this.horizontalSize;
      this.heightImage = this.verticalSize;
    }
  }

  onFile() {
    this.upload.emit();
  }

  onCancel() {
    this.cancelPhoto.emit();
  }
}
